<template>
  <el-table
    ref="table"
    border
    :data="tableData"
    style="width: 100%"
    max-height="570"
  >
    <!-- <el-table-column type="selection" width="55" /> -->

    <el-table-column type="index" label="序号" width="60" />

    <el-table-column
      prop="qymc"
      label="投标单位名称"
      show-overflow-tooltip
      min-width="180"
    >
      <template slot-scope="scope">
        <div style="display: flex; align-items: center">
          <p>{{ scope.row.qymc || scope.row.fcqymc }}</p>
          <div
            v-if="scope.row.lhtShowOrNo == 1"
            style="margin-left: 20px"
            class="btn-lht"
            @click="openLht(scope.row.lhtId)"
          >联合体</div>
        </div>
      </template>
    </el-table-column>

    <!-- 多轮/次报价 -->
    <template v-if="publishType">
      <el-table-column
        v-for="(item, index) in appendHead"
        width="140"
        show-overflow-tooltip
        :key="index"
        :label="getDcbjLabel(item)"
      >
        <template slot-scope="scope">
          {{ getDcbjValue(scope.row, index) }}
        </template>
      </el-table-column>
    </template>

    <el-table-column
      v-for="(val, key, index) in tableHead"
      width="150"
      show-overflow-tooltip
      :key="key + index"
      :label="key"
      :prop="val"
    />
  </el-table>
</template>

<script>
export default {
  props: {
    tableHead: {
      type: Object,
      default: () => {}
    },
    tableData: {
      type: Array,
      default: () => []
    },
    dcbjHead: {
      type: Array,
      default: () => []
    },
    publishType: {
      type: [Number, String],
      default: 2 // 1全部报价 2不发布报价 3最终报价
    },
    role: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      
    }
  },

  computed: {
    appendHead() {
      console.log('this.role ', this.role, this.dcbjHead)
      const len = this.dcbjHead.length
      if (this.role == 'Z' && this.publishType == 2 || this.publishType == 3) {
        return this.dcbjHead[len - 1] ? [this.dcbjHead[len - 1]] : []
      }
      return this.dcbjHead
    },

    isZbr() {
      return this.role == 'T'
    }
  },

  methods: {
    getDcbjLabel(item) {
      const { bjcsmc } = item
      return this.publishType != 2 || this.isZbr ? bjcsmc : '总报价（元）';
    },

    getDcbjValue(row, index) {
      if (!row.cgkbdcbjList || !row.cgkbdcbjList[index]) return ''
      const { bjje } = row.cgkbdcbjList[index];
      return this.publishType != 2 || this.isZbr ? bjje
        : bjje || bjje == 0 ? '已报价'
        : '未报价'
    },
    openLht(id) {
      this.$parent.openLht(id)
    }
  }
}
</script>